// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"836":"7334f92e973aecc2","1363":"c708b5633895ea19","4497":"3da299f565398e0e","6235":"5144c1fbd892dbac","9789":"aa91d7d63a89e80c"}[chunkId] + ".js";
};